import { AbortController } from 'ofetch'
import { useEnum } from "../stores/enum"

// 👉 IsEmpty
export const isEmpty = value => {
  if (value === null || value === undefined || value === '')
    return true
  
  return !!(Array.isArray(value) && value.length === 0)
}

// 👉 IsNullOrUndefined
export const isNullOrUndefined = value => {
  return value === null || value === undefined
}

// 👉 IsEmptyArray
export const isEmptyArray = arr => {
  return Array.isArray(arr) && arr.length === 0
}

// 👉 IsObject
export const isObject = obj => obj !== null && !!obj && typeof obj === 'object' && !Array.isArray(obj)

// 👉 IsToday
export const isToday = date => {
  const today = new Date()
  
  return (date.getDate() === today.getDate()
        && date.getMonth() === today.getMonth()
        && date.getFullYear() === today.getFullYear())
}

export const getEnumValue =async (enumName, isPrivate=false, filterKey=null) => {

  const enumData = await useEnum().fetchEnumByName(enumName, isPrivate)

  if (filterKey) {
    // object filter
    return computed(() => {
      return Object.keys(enumData[filterKey]).map(key => ({
        value: key,
        title: enumData[key],
      }))
    })
  }
  
  return computed(() => {
    return  Object.keys(enumData).map(key => ({
      value: key,
      title: enumData[key],
    }))??[]
  })

}

export const useListFetchingService = (url, params, beforeFetch={})=> {
  // Assuming params is a reactive object that can be watched for changes
  const { isFetching, data: dataList, execute } = useApi(createUrl(url, params), {
    ...beforeFetch,
    onSuccess: data => {
      dataList.value = data
    },
  })

  const data = computed(() => {
    return dataList.value ?? []
  })

  // Return the loading state and the data list
  return {
    isFetching,
    data,
    execute,
  }
}

export const updateObjectAsSelect=items=>{
  return items.map(item => {
    if (item.icon)
      item.icon = { icon: item.icon }
    if(item.color)
      item.color = item.color
    item.value = item.id
    item.title = item.name
    item.label = item.name
    
    return item
  })
}


export const resolveTicketStatusColor=status=>{
  switch (status) {
  case "Pending":
    return "warning"
  case "In Progress":
    return "warning"
  case "Snooze":
    return "info"
  case "Re-Assign":
    return "info"
  case "Re-Assign Request":
    return "info"
  case "Re-Open":
    return "info"
  case "Resolved":
    return "success"
  case "Disposed":
    return "error"
  case "Unattended":
    return "error"
  case "Noted Suggestion":
    return "error"
  case "Update":
    return "error"
  }
}


export const resolveTicketTypeColor = type => {
  const typeConfigs = {
    Complaint: {
      color: 'error',
      icon: 'tabler-alert-triangle',
    },
    Suggestion: {
      color: 'warning',
      icon: 'tabler-info-circle',
    },
    Request: {
      color: 'info',
      icon: 'tabler-help',
    },
    'Special Request': {
      color: 'info',
      icon: 'tabler-military-rank',
    },
    Compliment: {
      color: 'success',
      icon: 'tabler-mood-smile',
    },
    Query: {
      color: 'info',
      icon: 'tabler-message-question',
    },
    Feedback: {
      color: 'success',
      icon: 'tabler-clipboard-text',
    },
  }

  // Return the config for the type or the default config
  return typeConfigs[type] || {
    color: 'primary', // Changed from 'success' to 'primary' to avoid duplication
    icon: 'tabler-ticket',  // Changed to a different icon to avoid duplication
  }
}

export const resolveCapaStatusColor=status=>{
  switch (status) {
  case "Pending":
    return "warning"
  case "Re-Open":
    return "error"
  case "Done":
    return "success"
  default:
    return "info"
  }
}

export const resolveEscalationLevelBlock=level=>{
  switch (level) {
  case 1:
    return h("div", { class: "badge bg-success" }, "Level 1")
  case 2:
    return h("div", { class: "badge bg-warning" }, "Level 2")
  case 3:
    return h("div", { class: "badge bg-danger" }, "Level 3")
  default:
    return h("div", { class: "badge bg-info" }, "Level 0")
  }
}

export const resolveSmiley = value => {
  if (value >= 9) {
    return {
      icon: 'tabler-mood-happy-filled',
      color: 'success',
    }
  } else if (value >= 6) {
    return {
      icon: 'tabler-mood-neutral-filled',
      color: 'warning',
    }
  } else {
    return {
      icon: 'tabler-mood-sad-filled',
      color: 'error',
    }
  }
}



export const getTicketStatusBadge = status => {
  // 'Action Taken', 'Auto NFA', 'NFA', 'Pending''
  switch (status) {
  case 'Action Taken':
    return {
      color: 'success',
      icon: 'tabler-checks',
    }
  case 'Auto NFA':
    return {
      color: 'info',
      icon: 'tabler-check',
    }
  case 'NFA':
    return {
      color: 'error',
      icon: 'tabler-alert-circle',
    }
  case 'Pending':
    return {
      color: 'warning',
      icon: 'tabler-circle-x',
    }
  case 'In Progress':
    return {
      color: 'info',
      icon: 'tabler-progress',
    }
  case 'Re-Open':
    return {
      color: 'primary',
      icon: 'tabler-rotate-clockwise-2',
    }
  case 'Re-Assign':
    return {
      color: 'primary',
      icon: 'tabler-rotate-clockwise',
    }
  case 'Re-Assign Request':
    return {
      color: 'secondary',
      icon: 'tabler-rotate-rectangle',
    }
  case 'Unattended':
    return {
      color: 'error',
      icon: 'tabler-eye-off',
    }
  case 'Snooze':
    return {
      color: 'secondary',
      icon: 'tabler-eye',
    }
  case 'Resolved':
    return {
      color: 'success',
      icon: 'tabler-progress-check',
    }
  case 'Dispose':
    return {
      color: 'info',
      icon: 'tabler-trash',
    }
  default:
    return {
      color: 'primary',
      icon: 'tabler-circle-x',
    }
  }
}

export const getFeedbackStatusBadge = status => {
  switch (status) {
  case 'Action Taken':
    return {
      color: 'success',
      icon: 'tabler-checks',
    }
  case 'Auto NFA':
    return {
      color: 'info',
      icon: 'tabler-check',
    }
  case 'NFA':
    return {
      color: 'warning',
      icon: 'tabler-alert-circle',
    }
  case 'Pending':
    return {
      color: 'error',
      icon: 'tabler-clock',
    }
  case 'In Progress':
    return {
      color: 'primary',
      icon: 'tabler-progress',
    }
  default:
    return {
      color: 'secondary',
      icon: 'tabler-circle-x',
    }
  }
}

export const resolveCustomerCommunicationAvatar = status => {
  switch (status) {
  case 'Connected':
    return {
      color: 'success',
      icon: 'tabler-checks',
    }
  case 'Not Reachable':
    return {
      color: 'info',
      icon: 'tabler-phone-off',
    }
  case 'Not Connected':
    return {
      color: 'error',
      icon: 'tabler-circle-x',
    }
  case 'Pending':
    return {
      color: 'warning',
      icon: 'tabler-rotate-clockwise-2',
    }
  default:
    return {
      color: 'primary',
      icon: 'tabler-circle-x',
    }
  }
}

export const chartHoverCursorPointer = event => {
  event.target.style.cursor = "pointer"
}

export const downloadFile = (url, fileName, onSuccess, onError) => {
  let abortController = new AbortController()
  const { signal } = abortController
  let progress = 0
  const requestUrl = createUrl(url)
  
  $api(requestUrl.value, { signal }, (loaded, total) => {
    progress = total ? Math.floor((loaded / total) * 100) : 0
  }).then(data => {
    const downloadUrl = window.URL.createObjectURL(data)
    const link = document.createElement('a')

    link.href = downloadUrl
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    link.parentNode.removeChild(link)
    window.URL.revokeObjectURL(downloadUrl)
    onSuccess()
  }).catch(error => {
    if (error.name !== 'AbortError') {
      console.error('Download error:', error)
    }
    onError(error)
  })
}

// resolve incident status color
// DRAFT: 'DRAFT',
//   REQUEST_SUBMITTED: 'REQUEST_SUBMITTED',
//   DELEGATION_PENDING: 'DELEGATION_PENDING',
//   RCA_PENDING: 'RCA_PENDING',
//   REJECTED: 'REJECTED',
//   VERIFICATION_PENDING: 'VERIFICATION_PENDING',
//   CLOSURE_PENDING: 'CLOSURE_PENDING',
//   CLOSED: 'CLOSED',
export const resolveIncidentStatusColor = status => {
  switch (status) {
  case 'DRAFT':
    return 'secondary'
  case 'REQUEST_SUBMITTED':
    return 'primary'
  case 'DELEGATION_PENDING':
    return 'info'
  case 'RCA_PENDING':
    return 'amber-darken-3'
  case 'REJECTED':
    return 'error'
  case 'VERIFICATION_PENDING':
    return 'deep-orange-darken-2'
  case 'CLOSURE_PENDING':
    return 'warning'
  case 'CLOSED':
    return 'success'
  default:
    return 'info'
  }
}

export const resolveIncidentTypeIconColor = type => {
  switch (type) {
  case 'Clinical':
    return {
      icon: 'tabler-heart',
      color: 'error',
    }
  case 'Non-Clinical':
    return {
      icon: 'tabler-heart-off',
      color: 'primary',
    }
  default:
    return 'warning'
  }
}

export const checkImageUrl = url => {
  return new Promise(resolve => {
    const img = new Image()

    img.src = url
    img.onload = () => resolve(true)
    img.onerror = () => resolve(false)
  })
}

export const currentModule = () => {
  return window.location.pathname.split("/")[2]
}

export const MODULES = [
  {
    name: "Feedback",
    desc: "Manage Feedbacks",
    icon: "tabler-clipboard-text",
    to: '/app/feedback/dashboard',
  },
  {
    name: "Incident",
    desc: "Manage Incidents",
    icon: "tabler-traffic-cone",
    to: '/app/incident/dashboard',
  },
  {
    name: "Service Desk",
    desc: "Manage Service Desk",
    icon: "tabler-device-desktop",
    to: '/app/service-desk/dashboard',
  },
  {
    name: "Survey",
    desc: "Manage Surveys",
    icon: "tabler-speakerphone",
    to: '/app/survey/dashboard',
  },
  {
    name: "Care Visit",
    desc: "Manage Patient Visits",
    icon: "tabler-id-badge",
    to: '/app/care-visit/dashboard',
  },
]

export const convertToFormData = data => {
  const formData = new FormData()

  // Helper function to append nested objects
  const appendFormData = (formData, key, value) => {
    if (value instanceof File) {
      // Directly append File objects
      formData.append(key, value)
    } else if (Array.isArray(value)) {
      // Handle arrays
      value.forEach((item, index) => {
        appendFormData(formData, `${key}[${index}]`, item)
      })
    } else if (typeof value === 'object' && value !== null) {
      // Handle objects recursively
      Object.keys(value).forEach(subKey => {
        appendFormData(formData, `${key}[${subKey}]`, value[subKey])
      })
    } else if (value === null || value === undefined) {
      // Skip the value
    } else {
      // Append primitive values
      formData.append(key, value)
    }
  }

  // Iterate over the main object
  Object.keys(data).forEach(key => {
    appendFormData(formData, key, data[key])
  })

  return formData
}

export const matchObject = (obj1, obj2) => {
  // If both are strictly the same (including values)
  if (obj1 === obj2) return true

  // If either is not an object (or is null), return false
  if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
    return false
  }

  // Handle arrays explicitly
  if (Array.isArray(obj1) && Array.isArray(obj2)) {
    if (obj1.length !== obj2.length) return false
    for (let i = 0; i < obj1.length; i++) {
      if (!matchObject(obj1[i], obj2[i])) return false // Recursively compare each element
    }
    
    return true
  }

  // Get all keys from both objects
  const keys1 = Object.keys(obj1)
  const keys2 = Object.keys(obj2)

  // If objects don't have the same number of keys, return false
  if (keys1.length !== keys2.length) return false

  // Check if both objects have the same keys and values
  for (let key of keys1) {
    // Ignore the 'created_at' and 'updated_at' fields
    // if (key === 'created_at' || key === 'updated_at') continue;

    // Check recursively for nested objects or arrays
    if (!matchObject(obj1[key], obj2[key])) {
      return false
    }
  }

  return true
}

export const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.slice(0, maxLength - 3) + '...'
  }
  
  return text
}

export const executeWithLoader = async (loader, callback) => {
  loader.value = true
  try {
    const result = await callback()
    
    loader.value = false

    return result
  } catch(error) {
    console.error(error)
    loader.value = false
  }
}

export const formatRating = input => {
  const number = parseFloat(input)
  if (isNaN(number)) return

  return number.toFixed(1)
}

export const randomColor = () => {
  const colors = ['#7367f0', '#29c76f', '#01bad1']
  
  return colors[Math.floor(Math.random() * colors.length)]
}

export const iconPicker = () => {
  return [
    'tabler-box',
    'tabler-building-hospital',
    'tabler-clipboard-text',
    'tabler-traffic-cone',
    'tabler-nurse',
    'tabler-first-aid-kit',
    'tabler-first-aid-kit-off',
  ]
}

export const uniqueArray = (array, key = null) => {
  if (key) {
    return array.filter((v, i, arr) => arr.findIndex(obj => obj[key] === v[key]) === i)
  } else {
    return array.filter((v, i, arr) => arr.findIndex(obj => JSON.stringify(obj) === JSON.stringify(v)) === i)
  }
}

export const checkMediaDeletePermission = (media, loggedInUserId) => {
  return !media.uuid || media?.custom_properties?.user_id == loggedInUserId
}

export const dateTimePickerDateFormat = date => {
  return `${date.getFullYear()}-${(date.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`
}

export const radioRatingColor = value => {
  switch (value) {
  case "1":
    return '#FF5252'
  case "2":
    return '#FB8C00'
  case "3":
    return '#FFCA28'
  case "4":
    return '#00C853'
  case "5":
    return '#43A047'
  default:
    return '#fff'
  }
}


export const convertFileToBlobUrl = value => {
  if (value instanceof Blob || value instanceof File) {
    return URL.createObjectURL(value)
  }

  return value
}

/**
 * Converts a hex color to transparent by adding an alpha channel
 * @param {string} color - Hex color (e.g., "#ff5252" or "ff5252")
 * @param {number|string} alpha - Alpha value (0-1 decimal, 0-100 percentage, or hex string)
 * @returns {string} - Transparent hex color with alpha channel
 */
export const makeColorTransparent = (color, alpha = 0.22) => {
  // Remove # if present
  let hex = color.replace('#', '')
    
  // Ensure hex is 6 characters (expand shorthand)
  if (hex.length === 3) {
    hex = hex.split('').map(char => char + char).join('')
  }
    
  // Validate hex color
  if (!/^[0-9A-Fa-f]{6}$/.test(hex)) {
    throw new Error('Invalid hex color format')
  }
    
  let alphaHex
    
  // Handle different alpha input formats
  if (typeof alpha === 'string') {
    // If it's already a hex string (like "37")
    if (/^[0-9A-Fa-f]{1,2}$/.test(alpha)) {
      alphaHex = alpha.length === 1 ? '0' + alpha : alpha
    } else {
      throw new Error('Invalid alpha hex format')
    }
  } else if (typeof alpha === 'number') {
    if (alpha >= 0 && alpha <= 1) {
      // Decimal (0-1)
      alphaHex = Math.round(alpha * 255).toString(16).padStart(2, '0')
    } else if (alpha >= 0 && alpha <= 100) {
      // Percentage (0-100)
      alphaHex = Math.round((alpha / 100) * 255).toString(16).padStart(2, '0')
    } else {
      throw new Error('Alpha value must be between 0-1 (decimal) or 0-100 (percentage)')
    }
  } else {
    throw new Error('Alpha must be a number or hex string')
  }
    
  return `#${hex}${alphaHex}`
}

export const getUniqueColorFromColorsArray = (colorsArray, count) => {
  // Remove duplicates from the original array
  const uniqueColors = [...new Set(colorsArray)]
  
  // If requested count is greater than available unique colors, return all unique colors
  if (count >= uniqueColors.length) {
    return uniqueColors
  }
  
  // Shuffle the array and return the first 'count' elements
  const shuffled = uniqueColors.sort(() => 0.5 - Math.random())
  
  return shuffled.slice(0, count)
}

export const saveElementAsPDF = async (elementId, fileName, title = '') => {
  const { default: html2canvas } = await import('html2canvas')
  const { default: jsPDF } = await import('jspdf')

  const printContent = document.getElementById(elementId)
  if (!printContent) return

  const canvas = await html2canvas(printContent, {
    backgroundColor: '#ffffff',
    scale: 2,
    useCORS: true,
    allowTaint: false,
    logging: false,
    onclone: clonedDoc => {
      const icons = clonedDoc.querySelectorAll('[class*="tabler-"], [class*="custom-"]')

      icons.forEach(el => {
        const style = clonedDoc.defaultView.getComputedStyle(el)
        const maskImage = style.getPropertyValue('-webkit-mask-image') || style.getPropertyValue('mask-image')

        if (!maskImage || maskImage === 'none') return

        const bgColor = style.getPropertyValue('background-color')

        const svgMatch = maskImage.match(/url\("?(data:image\/svg\+xml[^")]*)"?\)/)
        if (!svgMatch) return

        let svgData = decodeURIComponent(svgMatch[1].replace('data:image/svg+xml,', ''))

        svgData = svgData.replace(/stroke='black'/g, `stroke='${bgColor}'`)
        svgData = svgData.replace(/fill='black'/g, `fill='${bgColor}'`)

        const encodedSvg = `url("data:image/svg+xml,${encodeURIComponent(svgData)}")`

        el.style.backgroundImage = encodedSvg
        el.style.backgroundColor = 'transparent'
        el.style.maskImage = 'none'
        el.style.webkitMaskImage = 'none'
        el.style.backgroundSize = '100% 100%'
        el.style.backgroundRepeat = 'no-repeat'
      })
    },
  })

  const imgData = canvas.toDataURL('image/png')

  const pdf = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a4',
  })

  const pageWidth = pdf.internal.pageSize.getWidth()
  const pageHeight = pdf.internal.pageSize.getHeight()
  const margin = 10
  const contentWidth = pageWidth - margin * 2

  // Draw title header if provided
  let contentStartY = margin

  if (title) {
    const headerHeight = 12
    const rootStyle = getComputedStyle(document.documentElement)
    const primaryRgb = rootStyle.getPropertyValue('--v-theme-primary').trim()
    const [r, g, b] = primaryRgb.split(',').map(v => parseInt(v.trim(), 10))

    pdf.setFillColor(r, g, b)
    pdf.roundedRect(margin, margin, contentWidth, headerHeight, 2, 2, 'F')
    pdf.setTextColor(255, 255, 255)
    pdf.setFontSize(14)
    pdf.setFont(undefined, 'bold')
    pdf.text(title, margin + 6, margin + headerHeight / 2 + 1.5)

    contentStartY = margin + headerHeight + 4
  }

  const availableHeight = pageHeight - contentStartY - margin
  const contentHeight = (canvas.height * contentWidth) / canvas.width

  if (contentHeight <= availableHeight) {
    pdf.addImage(imgData, 'PNG', margin, contentStartY, contentWidth, contentHeight)
  }
  else {
    // First page: use remaining space after header
    const firstPageHeight = availableHeight
    const scaledFirstPageHeight = (firstPageHeight * canvas.width) / contentWidth

    const firstSliceCanvas = document.createElement('canvas')

    firstSliceCanvas.width = canvas.width
    firstSliceCanvas.height = Math.min(scaledFirstPageHeight, canvas.height)

    const firstCtx = firstSliceCanvas.getContext('2d')

    firstCtx.drawImage(canvas, 0, 0, canvas.width, firstSliceCanvas.height, 0, 0, canvas.width, firstSliceCanvas.height)

    const firstSliceImg = firstSliceCanvas.toDataURL('image/png')
    const firstSliceRenderHeight = (firstSliceCanvas.height * contentWidth) / canvas.width

    pdf.addImage(firstSliceImg, 'PNG', margin, contentStartY, contentWidth, firstSliceRenderHeight)

    // Remaining pages
    let yOffset = firstSliceCanvas.height
    const pageContentHeight = pageHeight - margin * 2
    const scaledPageHeight = (pageContentHeight * canvas.width) / contentWidth

    while (yOffset < canvas.height) {
      pdf.addPage()

      const sliceHeight = Math.min(scaledPageHeight, canvas.height - yOffset)
      const sliceCanvas = document.createElement('canvas')

      sliceCanvas.width = canvas.width
      sliceCanvas.height = sliceHeight

      const ctx = sliceCanvas.getContext('2d')

      ctx.drawImage(canvas, 0, yOffset, canvas.width, sliceHeight, 0, 0, canvas.width, sliceHeight)

      const sliceImg = sliceCanvas.toDataURL('image/png')
      const sliceRenderHeight = (sliceHeight * contentWidth) / canvas.width

      pdf.addImage(sliceImg, 'PNG', margin, margin, contentWidth, sliceRenderHeight)

      yOffset += sliceHeight
    }
  }

  pdf.save(`${fileName}.pdf`)
}

export const colorPaletteForNPS = () => {
  return [
    '#f05c5c', // 0 - Red
    '#f07c56', // 1 - Red-orange
    '#f19c51', // 2 - Orange
    '#f4b04d', // 3 - Orange-yellow
    '#f6c448', // 4 - Yellow-orange
    '#f6d743', // 5 - Yellow
    '#e8dd4d', // 6 - Yellow-green
    '#d7e350', // 7 - Light yellow-green
    '#c5e557', // 8 - Light green
    '#a4e065', // 9 - Green
    '#81d35b',  // 10 - Darker green
  ]
}
